import {UIGameManager} from '../UIGameManager'
import {UIGamePlayerInformationView} from './UIGamePlayerInformationView'
import {ItemCountView} from '../../ui_canvas_engine/ItemCountView'
import {UIGameMechanic} from '../UIGameEventController'
import {GameStateEnums} from '../../../../../shared/GameEnums'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {VictoryPointStateReader, VictoryPointTypes} from '@colonist/game-base-types'
import {TranslationObject} from '@colonist/i18n'
import {UIUtilsEjsVariables} from '../../UIUtilsEjsVariables'

export abstract class UIGamePlayerInformationDefenderOfColonistView implements UIGameMechanic {
    private readonly uiGameManager: UIGameManager
    protected readonly isMyPlayer: boolean
    protected readonly playerInformation: UIGamePlayerInformationView
    protected defenderOfColonistView: ItemCountView

    constructor(uiGameManager: UIGameManager, playerInformation: UIGamePlayerInformationView) {
        this.uiGameManager = uiGameManager
        this.uiGameManager.eventController.registerUIGameMechanic(this)
        this.playerInformation = playerInformation

        const bottomPlayerColor = this.uiGameManager.gameController.isPlayerSpectator ? this.uiGameManager.gameController.playOrder[0] : this.uiGameManager.gameController.myColor
        this.isMyPlayer = this.playerInformation.player.color == bottomPlayerColor
        this.isMyPlayer ? this.createMyDefenderOfColonistView() : this.createOpponentDefenderOfColonistView()
        this.createTooltip()

        this.updateDefenderOfColonistCount()
        this.toggleProgressDefenderOfColonistView()
    }

    private createTooltip() {
        if(UIUtilsEjsVariables.isUserOnMobileAppOrWeb) return
        const defenderOfColonistTipTitle: TranslationObject = {key: 'strings:game.playerInformation.defenderOfColonist.title'}
        const defenderOfColonistTipBody: TranslationObject = {key: 'strings:game.playerInformation.defenderOfColonist.body'}
        this.defenderOfColonistView.view.setTip(defenderOfColonistTipTitle, [defenderOfColonistTipBody])
    }

    onEvent(data: any, eventType: UIGameEventEnums) {
        switch(eventType) {
            case UIGameEventEnums.PlayerControllerStateUpdated: this.updateDefenderOfColonistCount(); break
            case UIGameEventEnums.HoveredOverPlayerInformationArrow: this.defenderOfColonistView.showView(this.playerInformation); break
            case UIGameEventEnums.PointerOutPlayerInformationView: this.defenderOfColonistView.hideView(); break
            default: break
        }
    }

    protected abstract createMyDefenderOfColonistView()
    protected abstract createOpponentDefenderOfColonistView()

    private updateDefenderOfColonistCount() {
        const victoryPointsFromDefenderOfColonist = VictoryPointStateReader.totalVictoryPointsOfType(this.playerInformation.playerState.victoryPointsState, [VictoryPointTypes.DefenderOfColonist])
        this.defenderOfColonistView.updateText({key: 'strings:colonistCommon.utils.#buffer', options: {value: victoryPointsFromDefenderOfColonist}})
    }

    protected toggleProgressDefenderOfColonistView() {
        if(UIUtilsEjsVariables.isUserOnMobileAppOrWeb && UIUtilsEjsVariables.shouldDisplayNewMobileGameUI) return
        this.defenderOfColonistView.view.parent == undefined ? this.defenderOfColonistView.showView(this.playerInformation) : this.defenderOfColonistView.hideView()
    }

    destroy() {
        this.defenderOfColonistView.destroy()
        this.uiGameManager.eventController.unregisterUIGameMechanic(this)
    }
}
